import React from 'react';
import styled from 'styled-components';
import Separator from '../../UI/Separator';
import {FBIcon, Google} from './Icons';
import {wh} from '../../mixins';
import useLoadScripts from '../../scripts/ScriptProvider';
import GGL from '../../scripts/GGL';
import FB from '../../scripts/FB';
import {useDispatch} from 'react-redux';
import {sendSocialLoginRequest} from './authSlice';

const StyledButton = styled.button`
  ${wh('54px')};
  background-color: ${props => props.color};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${props => props.border ? '1px solid #E9E9E9' : `1px solid ${props.color}`};
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.11);
  cursor: pointer;
  
  &:focus {
    outline-color: #00BFA5;
  }
`;

const StyledContainer = styled.div`
  width: 125px;
  display: flex;
  justify-content: space-between;
`;


const Social = () => {
    const dispatch = useDispatch();

    useLoadScripts({ script: FB, check: 'FB' });
    useLoadScripts({ script: GGL.script, src: GGL.src, check: 'GoogleAuth' });

    const loginGGL = () => {
        window.GoogleAuth.signIn()
            .then(gglRes => {
                const res = gglRes.getAuthResponse();
                const params = {
                    access_token: res.access_token,
                    driver: 'google',
                };
                dispatch(sendSocialLoginRequest(params));
            });
    };

    const loginFB = () => {
        window.FB.login((res) => {
            if (res.status === 'connected') {
                const params = {
                    access_token: res.authResponse.accessToken,
                    driver: 'facebook'
                };
                dispatch(sendSocialLoginRequest(params));
            }
        }, { scope: 'email' });
    };

    return (
        <>
            <Separator>or continue with</Separator>
            <StyledContainer>
                <StyledButton color='#fff' border={true} onClick={loginGGL} id='continue-button'>{Google}</StyledButton>
                <StyledButton color='#4D6DA3' onClick={loginFB} id='continue-button'>{FBIcon}</StyledButton>
            </StyledContainer>
        </>
    );
};

export default Social;